/**
 * @generated SignedSource<<bdd809bede375f914544d11f82e41c09>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedPageTracker_item$data = {
  readonly isMultiSku: boolean;
  readonly skus: ReadonlyArray<{
    readonly images: ReadonlyArray<{
      readonly __typename: "ItemPhoto";
    } | null> | null;
    readonly skuId: string | null;
  } | null> | null;
  readonly " $fragmentType": "PdpSharedPageTracker_item";
};
export type PdpSharedPageTracker_item$key = {
  readonly " $data"?: PdpSharedPageTracker_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedPageTracker_item">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "PdpSharedPageTracker_item"
};

(node as any).hash = "dfba971de0748a6f43ebcbfebf8dd54c";

export default node;
